export default "__VITE_ASSET__C2pxs9Tr__"